
export default {
  name: "ProductFeatures",
  props: {
    features: {
      type: Array,
      required: true
    }
  },
};
